import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  modal: {
    position: "absolute",
    background: "#F5F8FF",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "0px",
    boxShadow: "0",
    zIndex: 9999,
    width: "994px",
    maxWidth: "95vw",
    maxHeight: "90vh",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  container: {
    padding: "32px 42px",
    background: "#F5F8FF",
    display: "flex",
    flexDirection: "column",
    gap: 30,
    overflowY: "auto",
  },
  title: {
    color: "#012397",
    fontFamily: "Cairo",
    fontWeight: 800,
    fontSize: 24,
    textAlign: "center",
  },
  sectionLabel: {
    fontFamily: "Cairo",
    fontWeight: 700,
    fontSize: 14,
    color: "#2A3333",
    marginBottom: 10,
  },
  uploadSection: {
    display: "flex",
    flexDirection: "column",
  },
  dropZone: {
    height: 200,
    width: "100%",
    borderRadius: 6,
    border: "1.5px dashed #6C7A7A",
    background: "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    gap: 6,
    transition: "border-color 0.15s",
  },
  dropZoneActive: {
    borderColor: "#3D63E6",
    background: "#EEF2FF",
  },
  dropPrimary: {
    fontFamily: "Cairo",
    fontWeight: 700,
    fontSize: 14,
    color: "#2A3333",
  },
  dropSecondary: {
    fontFamily: "Cairo",
    fontWeight: 400,
    fontSize: 14,
    color: "#6C7A7A",
  },
  uploadedWrap: {
    position: "relative",
    width: 220,
    height: 200,
    borderRadius: 6,
    overflow: "hidden",
    background: "#FFFFFF",
    border: "1px solid #E6EAEA",
  },
  uploadedImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
  deleteIcon: {
    position: "absolute",
    top: 8,
    right: 8,
    background: "rgba(255,255,255,0.9)",
    color: "#2A3333",
    padding: 4,
    "&:hover": { background: "#FFFFFF" },
  },
  collection: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: 10,
  },
  tile: {
    position: "relative",
    height: 200,
    borderRadius: 6,
    overflow: "hidden",
    cursor: "pointer",
    border: "2px solid transparent",
    transition: "border-color 0.15s",
  },
  tileSelected: {
    borderColor: "#3D63E6",
  },
  tileImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
  radio: {
    position: "absolute",
    top: 8,
    right: 8,
    width: 24,
    height: 24,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.9)",
    border: "2px solid #FFFFFF",
    boxShadow: "0 0 0 1px rgba(0,0,0,0.15)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  radioSelected: {
    background: "#3D63E6",
    "&::after": {
      content: '""',
      width: 10,
      height: 10,
      borderRadius: "50%",
      background: "#FFFFFF",
    },
  },
  actions: {
    display: "flex",
    justifyContent: "center",
    gap: 24,
    paddingTop: 8,
  },
  cancelBtn: {
    color: "#3D63E6",
    borderColor: "#3D63E6",
    "&:hover": { borderColor: "#3D63E6" },
    fontFamily: "Cairo",
    fontWeight: 700,
    fontSize: 16,
    width: 160,
    height: 50,
  },
  saveBtn: {
    background: "#3D63E6",
    color: "#fff",
    "&:hover": { background: "#3D63E6" },
    fontFamily: "Cairo",
    fontWeight: 700,
    fontSize: 16,
    width: 160,
    height: 50,
  },
  hiddenInput: {
    display: "none",
  },
}));
